import React, { lazy } from "react";
import Customize from "../pages/Customize";
import SaleQuantity from "../pages/SaleQuantity";

const createRouteConfig = (
  category,
  routes,
  layoutWrapper = true,
  additionalProps = {}
) => ({
  category,
  routes: routes.map((route) => ({
    ...route,
    layoutWrapper: route.layoutWrapper ?? layoutWrapper,
    props: { ...additionalProps, ...route.props },
  })),
});

const Contacts = lazy(() => import("../pages/Contacts"));
const BulkOrders = lazy(() => import("../pages/BulkOrders"));
const Users = lazy(() => import("../pages/Users"));

export const routeConfig = [
  createRouteConfig("dashboard", [
    { path: "/", component: React.lazy(() => import("../pages/Dashboard")) },
  ]),

  createRouteConfig("categories", [
    {
      path: "/categories",
      component: React.lazy(() => import("../pages/Categories/All")),
    },
    {
      path: "/categories/add",
      component: React.lazy(() => import("../pages/Categories/Add")),
    },
    {
      path: "/categories/update/:id",
      component: React.lazy(() => import("../pages/Categories/Update")),
    },
    {
      path: "/categories/filters/:id",
      component: React.lazy(() => import("../pages/Categories/Filters")),
    },
  ]),
  createRouteConfig("banner", [
    {
      path: "/banner",
      component: React.lazy(() => import("../pages/Banner")),
    },
  ]),

  createRouteConfig("misc", [
    {
      path: "/login",
      component: React.lazy(() => import("../pages/Login")),
      layoutWrapper: false,
    },
    {
      path: "/products",
      component: React.lazy(() => import("../pages/Products")),
    },
    {
      path: "/products/:id",
      component: React.lazy(() => import("../pages/ProductQuantity")),
    },
    {
      path: "/combos",
      component: React.lazy(() => import("../pages/Combos")),
    },
    {
      path: "/coupons",
      component: React.lazy(() => import("../pages/Coupons")),
    },
    {
      path: "/sales",
      component: React.lazy(() => import("../pages/Sales")),
    },
    {
      path: "/sales/:id/quantity",
      component: SaleQuantity,
      layoutWrapper: true,
    },
    {
      path: "/orders",
      component: React.lazy(() => import("../pages/Orders")),
    },
    {
      path: "/returns",
      component: React.lazy(() => import("../components/ReturnOrders")),
    },
    {
      path: "/orders/:id",
      component: React.lazy(() => import("../pages/OrderById")),
    },
    {
      path: "/admin/contacts",
      component: Contacts,
      layoutWrapper: true,
    },
    {
      path: "/admin/bulk-orders",
      component: BulkOrders,
      layoutWrapper: true,
    },
    {
      path: "/admin/users",
      component: Users,
      layoutWrapper: true,
    },
    {
      path: "/admin/users/:id/orders",
      component: React.lazy(() => import("../pages/UserOrders")),
      layoutWrapper: true,
    },
    {
      path: "/admin/customize",
      component: Customize,
      layoutWrapper: true,
    },
  ]),
];
